var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalStackedBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/HorBar/CompleteTransaction/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/HorBar/CompleteTransaction/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Complete-Transaction",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(12.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(123.965262, 87.962698)",
    fill: "#6BBE0B"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 10.2415459,
    height: 10.0373019,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(55.943298, 87.962698)",
    fill: "#798896"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 10.2415459,
    height: 10.0373019,
    rx: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6BBE0B",
    x: 145.885194,
    y: 23.9662458,
    width: 66.1148064,
    height: 55.3782173,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#798896",
    x: 0,
    y: 23.9662458,
    width: 144.357816,
    height: 55.3782173,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 63.4975845,
    y: 0,
    width: 83.9806763,
    height: 16.059683
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 84,
    y: 101,
    width: 22,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 153,
    y: 101,
    width: 22,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 153,
    y: 101,
    width: 22,
    height: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalStackedBar);
export default __webpack_public_path__ + "static/media/horizontal-stacked-bar.d55889637c93cff682a90e5fde519b9a.svg";
export { ForwardRef as ReactComponent };